import type { SubscriptionBlockViewDto } from '@subscriptions/application/dtos';
import { getInvoiceDisplayName } from './invoiceDisplayName';

/** True when the fiscal record carries everything the CFDI needs. */
export const hasCompleteInvoiceData = (invoiceData: SubscriptionBlockViewDto['invoiceData']): boolean =>
  Boolean(getInvoiceDisplayName(invoiceData) && invoiceData?.rfc?.trim() && invoiceData?.taxRegime?.trim());
